import React from "react";
import { SERVER_IP, ud, jwt, auth_response_flow } from "../../Server";
import swal from "sweetalert";
import axios from "axios";
import TableSkelton from "../../skeltonloader/TableSkelton";
import NoDataFound from "../../common/NoDataFound";

class AlignedWorkflowSiteAdmin extends React.Component {
  state = {
    allTypes: [],
    showChidComponent: false,
    selectedid: "",
    List: [],
    tempList: [],
    message: "",
    searchVal: "",
    loading: true,
  };


  componentDidMount() {
    const userInfo = sessionStorage.getItem("User_reports_info");
    if (!userInfo) {
      window.location.href = "/create/userlistreport";
      return;
    }
    this.fetchAlignedWorkflow();
  }


  handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    const { tempList } = this.state;

    const List = value === "" ? tempList : tempList.filter((w) => w.workflow_name.toLowerCase().includes(value));

    this.setState({ List, searchVal: value });
  };

  clearSearch = () => {
    this.setState({ List: this.state.tempList, searchVal: "" });
  };


  fetchAlignedWorkflow = async () => {
   

    const user_id = JSON.parse(sessionStorage.getItem("User_reports_info")).login_id;
    const payload = { user_id };
     this.setState({ loading: true });
    const headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };

    try {
      const { data } = await axios.post(`${SERVER_IP}/workflowList`, payload, {
        withCredentials: true,
        headers,
      });

      if (!data.error) {
        this.setState({
          List: data.workflowList,
          tempList: data.workflowList,
          message: "No Record Found",
          loading: false,
        });
      } else {
        auth_response_flow(data, (res) => {
          if (res.error === false && res.retry) {
            this.fetchAlignedWorkflow();
          } else {
            this.setState({ loading: false, message: "No Record Found" });
          }
        });
      }
    } catch (err) {
      swal("Something Went Wrong, Please Retry");
      this.setState({ loading: false, message: "No Record Found" });
    }
  };


  openSessions = (workflow) => {
    sessionStorage.setItem("report_info_session_siteadmin", JSON.stringify(workflow));
    window.location.href = "/create/alignedsessionsiteadmin";
  };


  render() {
    const { List, loading, message, searchVal } = this.state;

    return (
      <div>

        <div className="xp-breadcrumbbar">
          <div className="row">
            <div className="col-md-6 col-lg-6">
              <h4 className="xp-page-title">Aligned Workflows</h4>
            </div>
            <div className="col-md-12 col-lg-12">
              <div className="xp-breadcrumb gradient-border">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a onClick={() => (window.location.href = "/dashboard")}>
                      <i className="icon-home" />
                    </a>
                  </li>
                  <li className="breadcrumb-item">
                    <a onClick={() => (window.location.href = "/create/userlistreport")}>User List</a>
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>


        <div className="xp-contentbar p-30">
          <div className="row">
            <div className="col-lg-12">
              <div className="card document_gradient_border padding-0 border-before-15 m-b-30">
                <div className="card-header">
                  <div className="dv-center space-between">
                    <h5 className="card-title mb-0">Workflow List</h5>

      
                    <div className="autocomplete_search">
                      <input
                        type="text"
                        className="form-control ml-2"
                        placeholder="Search Workflow ..."
                        value={searchVal}
                        onChange={this.handleSearch}
                      />
                      {searchVal ? (
                        <span className="icon-close-search" onClick={this.clearSearch}>
                          <svg height="24" viewBox="0 0 24 24" width="24">
                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                          </svg>
                        </span>
                      ) : (
                        <span className="icon-search">
                          <svg height="24" viewBox="0 0 24 24" width="24">
                            <path d="M21 20l-5.8-5.8A7 7 0 1 0 15 15l5.8 5.8L21 20zM4 10a6 6 0 1 1 12 0A6 6 0 0 1 4 10z" />
                          </svg>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-striped table-bordered mcqlist-table">
                      <thead>
                        <tr>
                          <th className="text-center">S.N.</th>
                          <th>Name</th>
                          <th>Description</th>
                          <th className="text-center">Published On</th>
                          <th className="text-center">On‑Going</th>
                          <th className="text-center">Completed</th>
                          <th className="text-center">Session</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <TableSkelton rowCount={3} colCount={7} />
                        ) : List.length === 0 ? (
                          <tr>
                            <td colSpan={7} className="text-center">
                              <NoDataFound headText={message} />
                            </td>
                          </tr>
                        ) : (
                          List.map((wf, idx) => (
                            <tr key={wf.workflow_id ?? idx}>
                              <td className="text-center">{idx + 1}</td>
                              <td>{wf.workflow_name}</td>
                              <td>{wf.workflow_description}</td>
                              <td className="text-center">{wf.workflow_publishdate}</td>
                              <td className="text-center">{wf.workflow_total_ongoing ?? 0}</td>
                              <td className="text-center">{wf.workflow_total_completed ?? 0}</td>
                              <td className="text-center">
                                <button className="btn btn-info btn-sm" onClick={() => this.openSessions(wf)}>
                                  See Session
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AlignedWorkflowSiteAdmin;
